<div class="detail-card" fxLayout="column" fxLayoutGap="4px">
  <ul class="detail-card-list">
    <li attr.data-label="{{ 'DETAIL_ASSET_VARIABLE_CARD_COMPONENT.NAME' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(event()?.context?.asset?.name) | infoDisplay }}
    </li>
    <li attr.data-label="{{ 'DETAIL_ASSET_VARIABLE_CARD_COMPONENT.SHIP_TO' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(event()?.context?.asset?.shipTo) | infoDisplay }}
    </li>
    <li attr.data-label="{{ 'DETAIL_ASSET_VARIABLE_CARD_COMPONENT.VARIABLE' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(event()?.context?.assetVariable?.name) | infoDisplay }}
    </li>
    <li attr.data-label="{{ 'DETAIL_ASSET_VARIABLE_CARD_COMPONENT.EVENT_VALUE' | translate }}" class="detail-card-item">
      <span> {{ computedContextVariable() | valueUnitFormat }}</span>
      @if (event()?.context?.assetVariable?.value) {
        &nbsp;<span>({{ $safeNavigationMigration(event()?.occurrenceTime) | dateFormat }})</span>
      }
    </li>
    <li attr.data-label="{{ 'DETAIL_ASSET_VARIABLE_CARD_COMPONENT.COMMENT' | translate }}" class="detail-card-item">
      {{ $safeNavigationMigration(event()?.context?.assetVariable?.comment) | infoDisplay }}
    </li>
  </ul>
  <ul class="detail-card-list">
    <li attr.data-label="{{ 'DETAIL_ASSET_VARIABLE_CARD_COMPONENT.CURRENT_VALUE' | translate }}" class="detail-card-item">
      @if (event()?.context?.assetVariable.id && currentAssetVariable() === undefined) {
        <iot-platform-ui-card-loader [backgroundClass]="'users-detail-bp'" />
      } @else if (!!currentAssetVariable()) {
        <span class="detail-asset-variable-card-value"> {{ currentAssetVariable() | valueUnitFormat }} </span>
        <span>({{ $safeNavigationMigration(currentAssetVariable()?.lastValue?.datetime) | dateFormat | infoDisplay }})</span>
      } @else {
        <span>-</span>
      }
    </li>
  </ul>
</div>
